import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { UserPreference } from '../models';
import { UserPreferenceService } from './user-preference.service';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerSelectService {
  private readonly userPreferenceService = inject(UserPreferenceService);
  private readonly sessionService = inject(SessionService);

  static CustomerKey = 'customerId';
  skipUserPreferenceService = false;
  currentCustomer: string;

  getCustomer(): Observable<string> {
    return (
      this.skipUserPreferenceService ? of(undefined) : this.userPreferenceService.get(CustomerSelectService.CustomerKey)
    ).pipe(
      map((userPreference: UserPreference) => {
        let customer = userPreference?.value;
        if (!customer) {
          customer = this.sessionService.getString(CustomerSelectService.CustomerKey);
          if (customer && !this.skipUserPreferenceService) {
            this.userPreferenceService.set(CustomerSelectService.CustomerKey, customer).subscribe();
          }
        }
        const localCustomer = this.sessionService.getString(CustomerSelectService.CustomerKey);
        if (localCustomer !== customer) {
          this.setCustomer(customer).subscribe();
        }

        this.currentCustomer = customer;
        return customer;
      }),
    );
  }

  setCustomer(customer: string): Observable<any> {
    this.currentCustomer = customer;
    if (customer) {
      this.sessionService.setString(CustomerSelectService.CustomerKey, customer);
      if (!this.skipUserPreferenceService) {
        return this.userPreferenceService
          .set(CustomerSelectService.CustomerKey, customer)
          .pipe(tap(() => location.reload()));
      }
    }
    return of(undefined);
  }
}
